/**
 * Used to represent a function that does nothing.
 * Useful as a default value for a function.
 */
export default function noop(): void {
  return undefined;
}
